import { Injectable } from '@angular/core';
import { DocumentDisplayModel } from '@/api/model-index';
import * as saveAs from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class DocumentService
{
    constructor()
    {
        //
    }

    public download(document: DocumentDisplayModel)
    {
        if (document.content) {
            let byteCharacters = atob(document.content);
      
            let byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
      
            let byteArray = new Uint8Array(byteNumbers);
          
            if (document.contentMimeType) {
                var blob = new Blob([byteArray], { type: document.contentMimeType });
            
                if (document.name)
                    saveAs(blob, document.name);
            }
        }
    }
}
